import {keepPreviousData, queryOptions, useQuery} from '@tanstack/react-query'

import * as apiClient from '@/lib/api'
import {PERMISSIONS, ROLES} from '@/lib/auth/roles'
import {getGuideYear} from "@/lib/filters/date/date-utils";
import useIsQueryEnabled from '@/lib/hooks/query-enabler';
import {useQueryResetWithRefresh} from "@/lib/hooks/query-refetch-with-reset";
import {TopRatedStatusCompareFirmsApiResponse} from '@/modules/top-rated/compare-firms/types'
import {useToken} from '@/stores/token'
import {QUERY_KEY_TOP_RATED_STATUS_FIRM_LIST} from '@/utils/keys'

function fetchTopRatedStatusFirmList(): Promise<TopRatedStatusCompareFirmsApiResponse[]> {
  const guideYear = getGuideYear()

  return apiClient.get(`/firm/top-rated-firm-network/firm-list?guideYear=${guideYear}`)
}

export const topRatedStatusCompareFirmsQueryOptions = () =>
  queryOptions({
    queryKey: [QUERY_KEY_TOP_RATED_STATUS_FIRM_LIST],
    queryFn: () => fetchTopRatedStatusFirmList(),
    placeholderData: keepPreviousData
  })

export const useTopRatedStatusCompareFirms = () => {
  const {token} = useToken()
  const {permissions} = useToken()

  const queryOptions = topRatedStatusCompareFirmsQueryOptions()
  queryOptions.enabled = useIsQueryEnabled(!!(
    token?.roles.includes(ROLES.ROLE_ELEVATION)
    && permissions.includes(PERMISSIONS.IS_NETWORK_VIEW_ON_NETWORK)
  ))

  const query = useQuery(queryOptions)
  const {resetAndRefetch} = useQueryResetWithRefresh(queryOptions.queryKey, query.refetch)

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isPlaceholderData: query.isPlaceholderData,
    isError: query.isError,
    isRefetchError: query.isRefetchError,
    error: query.error,
    isRefetching: query.isRefetching,
    isSuccess: query.isSuccess,
    status: query.status,
    refetch: resetAndRefetch
  }
}


